"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CatalogCategory_1 = __importDefault(require("./CatalogCategory"));
exports.default = CatalogCategory_1.default;
